"use client";

import { AppFooter } from "./components/AppFooter";
import { AppHeader } from "./components/AppHeader";
import Menu from "./components/Menu";

export default function AppShell({
  children,
}: Readonly<{
  children: React.ReactNode;
}>): React.ReactElement {
  return (
    <>
      <AppHeader />

      <main className="isolate pt-4 pb-8 relative min-h-(--screen-minus-header) px-header-gap">{children}</main>

      <AppFooter />

      <Menu className="z-[6]" />
    </>
  );
}
